import { useQuery } from '@tanstack/react-query';

import { type PlayerDto, playerDtoToModel } from '@/models/players';
import { PlayerService } from '@/services/player/playerService';

export const getPlayerQuery = (playerId: string) => ({
  queryKey: ['player', playerId],
  queryFn: async () => PlayerService.getPlayer(playerId),
  enabled: !!playerId,
  select: (player: PlayerDto) => playerDtoToModel(player),
});
export const usePlayer = (playerId: string) => {
  return useQuery(getPlayerQuery(playerId));
};
